/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ progress: NonNullable<unknown> }} Ocr_Extracting_InvertedInputs */



/**
* | output |
* | --- |
* | "Extracting inverted frames... {progress}%" |
*
* @param {Ocr_Extracting_InvertedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_extracting_inverted = /** @type {((inputs: Ocr_Extracting_InvertedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Extracting_InvertedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Extraction des images inversées... ${i?.progress}%`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Extrahieren invertierter Frames... ${i?.progress}%`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Estrazione dei fotogrammi invertiti... ${i?.progress}%`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Извлечение инвертированных кадров... ${i?.progress}%`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Extrayendo fotogramas invertidos... ${i?.progress}%`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`正在提取反转帧... ${i?.progress}%`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`反転フレームを抽出中... ${i?.progress}%`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`उल्टे फ्रेम निकाले जा रहे हैं... ${i?.progress}%`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Extraindo quadros invertidos... ${i?.progress}%`)
	return /** @type {LocalizedString} */ (`Extracting inverted frames... ${i?.progress}%`)
});